import {Routes, Route, Navigate} from 'react-router-dom';
import {NotFound} from 'components';
import {PageARPreview, PageAR} from 'pages';

interface IRoutersProps {}

const Routers = ({}: IRoutersProps) => {
  return (
    <Routes>
      <Route path="/preview/:handle/:project" element={<PageARPreview />} />
      <Route path="/ar/:handle/:project" element={<PageAR />} />
      <Route path="/" element={<Navigate to="/ar/dasar/demo" />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default Routers;
